import {connect} from "react-redux";
import OpportunityList from "./list";
import {bindActionCreators} from "redux";
import {list, getOpportunityFilter} from "../../../service/Opportunities/action";
import {accountDetailsById} from "../../../service/Account/action";
const mapStateToProps = (state) => ({
    opportunityList:state.Opportunitie.opportunityList,
    getFilterContent:state.Opportunitie.getFilterContent,
    accountDetails:state.Dropdown.accountDetailsById,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            list,
            getOpportunityFilter,
            accountDetailsById
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(OpportunityList);
